import { Diagnostic, Rule } from "@siteimprove/alfa-act";
import { DOM } from "@siteimprove/alfa-aria";
import { Element, Namespace, Node, Query } from "@siteimprove/alfa-dom";
import { Predicate } from "@siteimprove/alfa-predicate";
import { Err, Ok } from "@siteimprove/alfa-result";
import { Criterion, Technique } from "@siteimprove/alfa-wcag";
import { expectation } from "../common/act/expectation.js";
import { Scope, Stability } from "../tags/index.js";
const { hasNonEmptyAccessibleName, hasRole, isIncludedInTheAccessibilityTree } = DOM;
const { hasNamespace } = Element;
const { and } = Predicate;
const { getElementDescendants } = Query;
export default Rule.Atomic.of({
    uri: "https://alfa.siteimprove.com/rules/sia-r2",
    requirements: [
        Criterion.of("1.1.1"),
        Technique.of("G94"),
        Technique.of("G95"),
    ],
    tags: [Scope.Component, Stability.Stable],
    evaluate({ device, document }) {
        return {
            applicability() {
                return getElementDescendants(document, Node.fullTree).filter(and(hasNamespace(Namespace.HTML), hasRole(device, "img"), isIncludedInTheAccessibilityTree(device)));
            },
            expectations(target) {
                return {
                    1: expectation(hasNonEmptyAccessibleName(device)(target), () => Outcomes.HasAccessibleName, () => Outcomes.HasNoAccessibleName),
                };
            },
        };
    },
});
/**
 * @public
 */
export var Outcomes;
(function (Outcomes) {
    Outcomes.HasAccessibleName = Ok.of(Diagnostic.of(`The image has an accessible name`));
    Outcomes.HasNoAccessibleName = Err.of(Diagnostic.of(`The image does not have an accessible name`));
})(Outcomes || (Outcomes = {}));
//# sourceMappingURL=rule.js.map